/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EducationProgramPagedData } from '../../models/education-program-paged-data';
import { SortType } from '../../models/sort-type';

export interface GetEducationPrograms$Params {
  PageNumber?: number;
  PageSize?: number;
  Favorites?: boolean;
  SearchTerm?: string;
  Location?: string;
  MaximumDistance?: number;
  SortField?: string;
  SortType?: SortType;
}

export function getEducationPrograms(http: HttpClient, rootUrl: string, params?: GetEducationPrograms$Params, context?: HttpContext): Observable<StrictHttpResponse<EducationProgramPagedData>> {
  const rb = new RequestBuilder(rootUrl, getEducationPrograms.PATH, 'get');
  if (params) {
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
    rb.query('Favorites', params.Favorites, {});
    rb.query('SearchTerm', params.SearchTerm, {});
    rb.query('Location', params.Location, {});
    rb.query('MaximumDistance', params.MaximumDistance, {});
    rb.query('SortField', params.SortField, {});
    rb.query('SortType', params.SortType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EducationProgramPagedData>;
    })
  );
}

getEducationPrograms.PATH = '/educationprogram';
